import { Component, Inject } from "@angular/core";
import { ConfHeaderValue, HeaderPanel } from "../../../shared/models";
import { ConfiguratorStore, ConfPageSessionService } from "../../providers";
import { PanelComponent } from "../../shared/panelComponent";
import { VisualObjectHelper } from "../../parameters/shared";

@Component({
  selector: 'header-panel',
  templateUrl: './headerPanelComponent.html'
})
export class HeaderPanelComponent extends PanelComponent<HeaderPanel> {

  classes: string;
  confHeaderValue: ConfHeaderValue;

  constructor(
    public confStore: ConfiguratorStore,
    public confPageSessionService: ConfPageSessionService,
    @Inject(VisualObjectHelper) public visualObjectHelper: VisualObjectHelper
  ) {
    super(confStore, confPageSessionService, visualObjectHelper);
  }

  ngOnInit(): void {
    this.confHeaderValue = this.confStore.getConfDataEntity<ConfHeaderValue>(this.configuration.longId, this.confSessionId, this.panel.longId);    
    this.update();
    super.ngOnInit();
  }

  public listenChanges(): void {
    this.confStore.onConfigurationValueChange(this.configurationId, this.confSessionId, this.panel.longId, (value: ConfHeaderValue): void => {
      this.confHeaderValue = value;
      this.update();
    }).unsubscribeOn(this.unsubscribeSubject);
  }

  public update() {
    if (this.panel.minorHeader)
      this.classes = "minor-header";
    else
      this.classes = "major-header";
  }
}